<template lang="pug">
.d-flex.mr-1
    .suus__label__container.pl-1.d-flex.align-center(:style="containerStyles")
        UnionIcon(:width="16" :height="16" :color="setColor")
        .suus__label__text.pl-2.d-flex.align-center(:style="labelStyles") {{ text }}
    svg(:height="height" viewBox="0 0 44 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="overflow: visible")
        path(:d=`'M0 1H'+height*1.75+'L16.8 '+height+'H7'` :stroke="setColor" stroke-width="2")
</template>

<script lang="ts">
import Vue from "vue"
import UnionIcon from "../icons/UnionIcon.vue"

export default Vue.extend({
  name: "FlagTag",
  props: {
    text: { type: String, required: true },
    height: { type: Number, default: 24 },
    color: { type: String, default: "primary" },
  },
  components: {
    UnionIcon,
  },
  computed: {
    setColor(): string | undefined {
      return this.color === "primary"
        ? this.$vuetify.theme.themes.light.primary?.toString()
        : this.$vuetify.theme.themes.light.textColor?.toString()
    },
    labelStyles(): object {
      return {
        maxWidth: this.$vuetify.breakpoint.name === "xs" ? "200px" : "250px",
        color: this.setColor,
        fontSize: "0.8rem !important",
        lineHeight: "0.8rem !important",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        ...this.fontStyles,
      }
    },
    containerStyles(): object {
      return {
        height: this.height,
        minWidth: "120px",
        borderLeft: `2px solid ${this.setColor}`,
        borderTop: `2px solid ${this.setColor}`,
        borderBottom: `2px solid ${this.setColor}`,
        marginRight: "-8px",
        borderRadius: "2px 0 0 2px",
        ...this.fontStyles,
      }
    },
    fontStyles(): object {
      return {
        fontFamily: "system-ui !important",
        color: `${this.setColor} !important`,
        fontWeight: "900 !important",
      }
    },
  },
})
</script>
